import { isEmpty } from 'ramda';

import getTruthyKeys from '../../../utils/getTruthyKeys';

export const textFilterMethod = (data, dataIndex, filterValue) => {
    if (!filterValue) return true;

    return data[dataIndex]?.toLowerCase().includes(filterValue?.toLowerCase());
};

export const selectFilterMethod = (data, dataIndex, filterValue) => {
    if (!filterValue) return true;

    const selectedFilters = getTruthyKeys(filterValue);

    if (isEmpty(selectedFilters)) return true;

    if (data[dataIndex]) {
        return selectedFilters.some(selected => data[dataIndex] === selected);
    }

    return false;
};

export const filterByFilterMethod = (type: 'text' | 'select') => {
    if (type === 'text') return textFilterMethod;

    if (type === 'select') return selectFilterMethod;

    return null;
};
